import { inject, Injectable } from '@angular/core';
import { TranslateOrDefault } from '@language';
import { TranslateService } from '@ngx-translate/core';
import { DottedKey } from '../../../../core/field-definitions/entities/field-definition.entity';
import { ExtendedProfileField } from '../../../../core/profiles/entities/extended-profile-field.entity';
import { ApiFragment } from '../../../../core/records/entities/api-fragment.class';
import { VersioningStatus } from '../../../../core/records/entities/metadata/metadata.entity';
import { Cell } from '../../components/cells/_base/table-cell.entity';
import { TextCell } from '../../components/cells/text-cell/text-cell.entity';
import { ColumnWidth } from '../../entities/column-width.entity';
import { ProfileFieldColumnService } from '../base-columns/profile-field-column.service';

@Injectable({ providedIn: 'root' })
export class VersioningStatusColumnService extends ProfileFieldColumnService<ApiFragment> {
    protected readonly WIDTH: ColumnWidth = ColumnWidth.NORMAL;
    protected readonly DISABLE_SORT: boolean = true;
    protected readonly WRAP_TEXT: boolean = false;

    private readonly translateService: TranslateService = inject(TranslateService);

    protected getMapper(profileField: ExtendedProfileField): (item: ApiFragment) => Cell {
        return record => {
            const status = record.getVersioningStatus();
            const label: string = this.translateVersioningStatus(status);
            return new TextCell(label, this.WRAP_TEXT);
        };
    }

    private translateVersioningStatus(status: VersioningStatus): string {
        return TranslateOrDefault(this.translateService, `overrides.VersioningStatus.${status}`, status);
    }

    protected getFieldSelectDottedKeys(profileField: ExtendedProfileField): DottedKey[] {
        return ['Structural.Versioning'] as DottedKey[];
    }
}
